export const CloseIcon = ({
  color = '#5D6293',
  onClick,
}: {
  color?: string;
  onClick?: () => void;
}) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={onClick}
  >
    <path
      d='M15.2471 5.92925C15.5716 5.60478 15.5716 5.07872 15.2471 4.75425C14.9227 4.42978 14.3966 4.42978 14.0721 4.75425L10.0013 8.82508L5.93047 4.75425C5.606 4.42978 5.07994 4.42978 4.75547 4.75425C4.431 5.07872 4.431 5.60478 4.75547 5.92925L8.8263 10.0001L4.75547 14.0709C4.431 14.3954 4.431 14.9215 4.75547 15.2459C5.07994 15.5704 5.606 15.5704 5.93047 15.2459L10.0013 11.1751L14.0721 15.2459C14.3966 15.5704 14.9227 15.5704 15.2471 15.2459C15.5716 14.9214 15.5716 14.3954 15.2471 14.0709L11.1763 10.0001L15.2471 5.92925Z'
      fill={color}
    />
  </svg>
);
